import React from 'react';
import { Row, Col } from 'react-bootstrap';
import NavBar from '../components/NavBar';

class AboutPage extends React.Component {
  render() {
    return (
      <div className="container"> 
        <NavBar activeKey="about" />
        <Row className="mb-4"/>
        <Row>
          <Col>
            <h1>About Me</h1>
            <p>I'm an Assistant Professor in Computer Science at Harvey Mudd College, a small undergraduate-only college centered on educating STEM students as leaders not only through strong technical knowledge but also deep understanding and appreciation of humanities and the social sciences. My passions are using tools from natural language processing for digital humanities and computational social science work, privacy in text models, and teaching about impact and ethics in all CS classes.</p>

            <p>I finished my Ph.D. in Computer Science at Cornell University in 2019. My doctoral work, advised by <a href="https://mimno.infosci.cornell.edu/">Prof. David Mimno</a>, focused on understanding and improving latent variable models for analysis of real-world datasets by humanist and social science researchers. This work also included ideas on how to integrate privacy into machine-learning-aided data mining in NLP to protect individuals and ideas.</p>

            <p>Prior to starting my Ph.D. at Cornell University, I received my B.S. from <a href="https://cs.hmc.edu">Harvey Mudd College</a> in Math and Computer Science. I also worked for a short time on the search team at <a href="https://www.yelp.com">Yelp</a>.</p>
            
            {/* <p>I <a href="https://twitter.com/XandaSchofield">tweet</a> and occasionally write <a href="https://www.xandaschofield.com/">blog posts</a> about computing, being a junior academic, and baking cookies.</p> */}

            <br/>

            <h2>Old Blog Posts (from back when I blogged):</h2>
            <ul>
                <li>February 2019: <a href="https://blogs.cornell.edu/cornellnlp/2019/02/09/choose-your-words-wisely-for-topic-models/">Choose Your Words Wisely (for Topic Models)</a></li>
                <li>August 2018: <a href="http://www.xandaschofield.com/2018/08/the-talk-first-strategy-of-poster-design.html">The Talk-First Strategy of Poster Design</a></li>
                <li>February 2018: <a href="http://www.xandaschofield.com/2018/02/building-your-network-as-a-young-phd.html">Building Your Network as a Young PhD Student: Emails</a></li>
                <li>October 2015: <a href="http://www.xandaschofield.com/2014/10/what-is-impostor-syndrome.html">What is Impostor Syndrome?</a></li>
                <li>April 2015: <a href="http://www.cs.cornell.edu/~xanda/interviews.html">Mastering the Software Engineering Interview</a></li>
            </ul>

          </Col>
        </Row>
      </div>
      
    );
  }
}

export default AboutPage;
